import React from 'react';

import { useRouter } from 'next/router';
import { FeedActivityItem } from '@components/Feed/Activities/FeedActivityItem';
import { FeedPost } from '@components/Feed/Post';
import { CommentButtonAction } from '@components/Feed/Post/ActionButtons';
import { PostDropdown } from '@components/Feed/Post/Dropdown';
import { useAuth } from '@context/auth/base';
import type { FragmentType } from '@graphql/reactQuery';
import {
  FeedActivityTypePostFragmentDoc,
  FeedReleasePostFragmentDoc,
  getFragment,
  gql,
} from '@graphql/reactQuery';
import { trackClickEvent } from '@lib/analytics';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment FeedActivityTypePost on UserCreatedPostAggregate {
    post {
      ...FeedReleasePost
    }
  }
`);

export function FeedActivityTypePost({
  activityFrag,
  timeStamp,
}: {
  activityFrag: FragmentType<FeedActivityTypePostFragmentDoc>;
  timeStamp: number;
}) {
  const activity = getFragment(FeedActivityTypePostFragmentDoc, activityFrag);
  const { push } = useRouter();
  const { authUser } = useAuth();
  if (!activity.post) {
    return <div className="text-base-s text-neutral400">This post has been deleted</div>;
  }

  const post = getFragment(FeedReleasePostFragmentDoc, activity.post);

  return (
    <div
      className="-m-3 cursor-pointer rounded-lg p-3 hover:bg-neutral50 hover:[&_.read-more-button]:bg-neutral200 [&_.read-more-overlay]:hover:from-neutral50"
      data-feed-clickable-div
      onClick={e => {
        if (e.target instanceof HTMLElement) {
          if (e.target.hasAttribute('data-feed-clickable-div')) {
            push(webappUriPath(post.webappUri));

            trackClickEvent({
              event: 'Post Link Clicked',
              properties: {
                associationId: post.id,
                associationType: 'Post',
                sourceComponent: 'Feed Post',
              },
            });
          }
        }
      }}
    >
      <FeedActivityItem
        isPost
        userFrag={post.creator}
        description="Posted"
        timestamp={timeStamp}
        dropdownContent={
          post.creator.id === authUser?.id ? <PostDropdown postId={post.id} /> : null
        }
      >
        <FeedPost
          collectButtonSource="Feed Post Sound Bar"
          commentButtonAction={CommentButtonAction.ShowModal}
          releasePostFrag={activity.post}
          shareButtonSource="Post Feed Card"
        />
      </FeedActivityItem>
    </div>
  );
}
